import React, { useEffect, useState, useMemo } from "react";
import BodyHeader from "../../components/customComp/BodyHeader";
import UsersBody from "./users/UsersBody";
import constants from "../../utils/constants";
import formData from "../../components/forms/formsData.json";
import PopUpWindow from "../../components/popups/PopUpWindow";
import { object, string } from "yup";
import Constants from "../../utils/constants";
import { authenticationService } from "../../services/AuthinticationService";
import SystemMessage from "../../components/customComp/SystemMessage";

const UserListComp = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [filtersObj, setFiltersObj] = useState({});
  const [searchInput, setSearchInput] = useState("");
  const [currentForm, setCurrentForm] = useState(formData["add_user"]);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [userEditEntry, setUserEditEntry] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [systemError, setSystemError] = useState(null);
  const [systemErrorCount, setSystemErrorCount] = useState(0);

  const handleSystemError = (message) => {
    setSystemError(message);
    setSystemErrorCount((c) => c + 1);
  };

  const clearSystemError = () => {
    setSystemError(null);
  };


  const validateSchema = object().shape({
    First_name: string().required("This field is required"),
    Last_name: string().required("This field is required"),
    Email: string()
      .required("This field is a required field")
      .matches(Constants.emailRegExp, "Invalid Email"),
    Phone_Number: string().required("This field is required"),
    Site_index: string().required("This field is required"),
  });

  const searchMatches = useMemo(() => {
    if (usersData && searchInput?.length > 0) {
      return usersData.filter((user) =>
        `${user.First_name} ${user.Last_name}`
          .toLowerCase()
          .includes(searchInput.toLowerCase())
      );
    } else {
      return [];
    }
  }, [usersData, searchInput]);

  useEffect(() => {
    getAllUsers(filtersObj).then((res) => {
      if (res?.data) {
        setUsersData(res.data);
      }
    });
    setIsLoading(false);
  }, [isLoading]);

  const getAllUsers = async (filters) => {
    return await props.restApi.getAllUsers(filters);
  };

  const getSites = async () => {
    debugger
    // if the user is super admin - fetch all sites. 
    if (authenticationService.currentUserValue.profile.Role == "SuperAdmin"){
      const response = await props.restApi.getAllSites();
      if (!(response && response.data)) return [];
      return response.data.map((item) => {
        return { label: item.Site_name, value: item.Site_index };
      });    
    }
    // if the user is admin, show case only the user's site (admin can see only its own site)
    if (authenticationService.currentUserValue.profile.Role == "Admin"){
      return[{label: authenticationService.currentUserValue.profile.HCP, value: authenticationService.currentUserValue.profile.Site_index}]
    }

  };

  const handleOpenPopup = async () => {
    // Fetch the list of site options from the API
    const sitesData = await getSites();

    // Deep clone and update the Site_index field with dropdown options
    const updatedForm = currentForm.map((section) => {
      return {
        ...section,
        inputs: section.inputs.map((input) => {
          if (input.name === "Site_index") {
            return {
              ...input,
              data: sitesData,
            };
          }
          return input;
        }),
      };
    });

    // Update form state
    setCurrentForm(updatedForm);

    // Reset search and open popup
    setSearchInput("");
    document.body.style.overflow = "auto";
    setIsPopUpOpen(true);
  };

  const handleClosePopUp = () => {
    document.body.style.overflow = "auto";
    setIsPopUpOpen(false);
    setIsEditMode(false);
    setUserEditEntry({});
  };

  const handlePostApi = async (entry) => {
    let response; 
    try {
      debugger
      if (!isEditMode) {
        response = await props.restApi.createUser(entry);
      } else {
        debugger
        response = await props.restApi.editUser(entry);
      } 

      if (response && response.status < 400 && response.data) {
        handleClosePopUp();
        setIsLoading(true);
      }
    } catch (error) {
      console.log("AXIOS ERROR:", error);
    
      let backendMessage = "Cannot Create User.";
      console.log(response)
    
      // Most common Axios pattern
      if (error?.response?.data?.error) {
        backendMessage = error.response.data.error;
      }
    
      // Fallback — sometimes server sends 'message'
      else if (error?.response?.data?.message) {
        backendMessage = error.response.data.message;
      }
    
      // Fallback — if error.response exists but no 'error' key
      else if (typeof error?.response?.data === "string") {
        backendMessage = error.response.data;
      }
    
      handleSystemError(backendMessage);
    }
    
  };


  const handleEditMode = (index) => {
    setIsEditMode(true);
    setUserEditEntry(usersData[index]);
    handleOpenPopup();
  };

  const handleDropDownChange = async (index, name, value) => {
    await props.restApi.editUser({
      ...usersData[index],
      [name]: value,
    });

    usersData[index][name] = value;
    setUsersData([...usersData]);
  };

  return (
    <>
      {systemError && (
        <SystemMessage
          type="error"
          title="Error"
          key={`${systemError}${systemErrorCount}`}
          message={systemError}
          handleClose={clearSystemError}
        />
      )}
  
      <div className="w-full px-12 pt-4 pb-16 h-full max-h-full overflow-hidden box-border bg-[#161616]">
        <div className="flex justify-between w-100">
          <BodyHeader
            title={"Users"}
            includeButton={true}
            buttonText={"Create Users"}
            includeSubtext={false}
            hasSearch={true}
            includePlus={true}
            searchInput={searchInput}
            searchMatches={searchMatches}
            setSearchInput={setSearchInput}
            onButtonClick={handleOpenPopup}
            onSearchItemClick={handleEditMode}
            searchType="user"
          />
        </div>
  
        <div className="h-full max-h-full overflow-clip">
          {isPopUpOpen && (
            <PopUpWindow
              validateSchema={validateSchema}
              additionalForm={[
                {
                  key: "Status",
                  value: "Enable",
                  text: "Enable or disable the user",
                  options: [
                    { label: "Enable", value: "Enable" },
                    { label: "Disable", value: "Disable" },
                  ],
                },
                {
                  key: "Role",
                  value: "Radiologist",
                  text: "User role",
                  options: [
                    { label: "Radiologist", value: "Radiologist" },
                    { label: "Admin", value: "Admin" },
                  ],
                },
              ]}
              handlePostApi={handlePostApi}
              isPopUpOpen={isPopUpOpen}
              formSections={currentForm}
              editEntry={
                isEditMode
                  ? {
                      ...userEditEntry,
                      Role: userEditEntry.Role || "Radiologist",
                      Status: userEditEntry.Status || "Enable",
                    }
                  : {
                      Role: "Radiologist",
                      Status: "Enable",
                      Site_index: "",
                    }
              }
              isEditMode={isEditMode}
              editModeText={"Edit Radiologist / Admin"}
              popupTitle={"Create Radiologist / Admin"}
              submitText={"Create"}
              updateText={"Update"}
              closePopUp={handleClosePopUp}
            />
          )}
  
          <UsersBody
            usersData={usersData}
            addTab={props.addTab}
            handleDropDownChange={handleDropDownChange}
            onRowClick={handleEditMode}
          />
        </div>
      </div>
    </>
  );
  
  
};

export default UserListComp;
